import { render, staticRenderFns } from "./TechnicalReport.vue?vue&type=template&id=18926717&scoped=true&"
import script from "./TechnicalReport.vue?vue&type=script&lang=js&"
export * from "./TechnicalReport.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalReport.vue?vue&type=style&index=0&id=18926717&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18926717",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSpace,QCarousel,QCarouselSlide,QScrollArea,QBtnToggle,QItem,QItemSection,QItemLabel,QSeparator,QChip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSpace,QCarousel,QCarouselSlide,QScrollArea,QBtnToggle,QItem,QItemSection,QItemLabel,QSeparator,QChip})
